/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum BackgroundJobExecutor {
    AI = 'AI',
    AI_AGENT = 'AI_AGENT',
    AI_BG = 'AI_BG',
    BROKER = 'BROKER',
    COMPLIANCE = 'COMPLIANCE',
    COMPLIANCE_BG = 'COMPLIANCE_BG',
    COST = 'COST',
    COST_BG = 'COST_BG',
    COST_BG_CLOUD_BILLING = 'COST_BG_CLOUD_BILLING',
    COST_BG_K8S_BILLING = 'COST_BG_K8S_BILLING',
    FEATURE_FLAGS = 'FEATURE_FLAGS',
    HEATSTACK = 'HEATSTACK',
    HEATSTACK_BG = 'HEATSTACK_BG',
    HEATSTACK_BG_POLICY = 'HEATSTACK_BG_POLICY',
    HEATSTACK_BG_SCHEDULER = 'HEATSTACK_BG_SCHEDULER',
    HEATSTACK_BG_TEMPLATE = 'HEATSTACK_BG_TEMPLATE',
    IDENTITY = 'IDENTITY',
    IDENTITY_BG = 'IDENTITY_BG',
    OPERATIONS = 'OPERATIONS',
    OPERATIONS_BG = 'OPERATIONS_BG',
    REPORT_GENERATION = 'REPORT_GENERATION',
    RESOURCE_INVENTORY = 'RESOURCE_INVENTORY',
    RESOURCE_INVENTORY_BG = 'RESOURCE_INVENTORY_BG',
    SECURITY = 'SECURITY',
    SECURITY_BG = 'SECURITY_BG'
}
